package com.shadowings.gero.data.lessons.chapter2

import androidx.compose.foundation.layout.Column
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.TrueFalseContent
import com.shadowings.gero.presentation.component.MdCWord
import gero.composeapp.generated.resources.*

fun getPhoneticComplementsContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_i_complementi_fonetici,
            content = Res.string.exp_content_prima_di_imparare_altre_parole_dobbiamo_capir,
            face = Faces.Happy
        ),
        ExplanationContent(
            title = Res.string.exp_title_rafforzare_i_suoni,
            content = Res.string.exp_content_i_complementi_fonetici_sono_segni_monolitteri,
            face = Faces.Serious
        ),
        ExplanationContent(
            title = Res.string.exp_title_rafforzare_i_suoni_2,
            content = Res.string.exp_content_non_vanno_pronunciati_due_volte_servono_solo_,
            face = Faces.Surprised
        ),
        ExplanationContent(
            title = Res.string.exp_title_esempio_la_parola_balia,
            content = Res.string.exp_content_la_parola_balia_mna_in_realt_scritta_mnna_la_,
            face = Faces.Idle,
            composable = {
                Column {
                    MdCWord(word = "Y5:N35:D36-B8", rtl = false, cart = false)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_tradizione_e_simmetria,
            content = Res.string.exp_content_a_volte_gli_scribi_aggiungevano_segni_silenzi,
            face = Faces.Surprised
        ),
        ExplanationContent(
            title = Res.string.exp_title_esempio_padre_it,
            content = Res.string.exp_content_nella_parola_padre_it_il_segno_del_serpente_f,
            face = Faces.Happy,
            composable = {
                Column {
                    MdCWord(word = "M17-X1:I9-A1", rtl = false, cart = false)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_omissioni_e_abbreviazioni,
            content = Res.string.exp_content_per_risparmiare_spazio_o_motivi_artistici_gli,
            face = Faces.Serious
        ),
        ExplanationContent(
            title = Res.string.exp_title_esempio_uomo_rmt,
            content = Res.string.exp_content_nella_parola_uomo_rmt_il_segno_monolittero_pe,
            face = Faces.Idle,
            composable = {
                Column {
                    MdCWord(word = "D21:V13-A1", rtl = false, cart = false)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_nilo,
            content = Res.string.exp_content_miao,
            face = Faces.Idle,
            character = Characters.Nilo
        ),
        ExplanationContent(
            title = Res.string.exp_title_mettiti_alla_prova,
            content = Res.string.exp_content_lezione_finita,
            face = Faces.Perfect
        )
    )
}

fun getPhoneticComplementsQuizContent(): List<IQuizContent> {
    return listOf(
        TrueFalseContent(
            text = Res.string.quiz_phonetic_confermare_lettura,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_phonetic_pronunciato_due_volte,
            correct = false
        ),
        TrueFalseContent(
            text = Res.string.quiz_phonetic_segni_silenziosi,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_phonetic_omettere_suoni,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_phonetic_vietato_omettere,
            correct = false
        ),
        TrueFalseContent(
            text = Res.string.quiz_phonetic_ordine_spostamenti,
            correct = true
        )
    ).shuffled()
}

